import axios from 'axios';

export class ServiceApi {

    static _getUrl() {
        return axios.get('config.json')
            .then(res => res.data.servico)
            .then(url => {
                if (url[url.length - 1] === "/")
                    return url;
                return url + "/";
            });
    }

    static _getCnpj() {
        return axios.get('config.json')
            .then(res => {
                return res.data.cnpjCliente
            });
    }

    static post(address, body) {
        return this._getUrl()
            .then(root => axios.post(`${root}${address}`, body))
            .then(res => res.data);
    }

    static get(url) {
        return axios.get(url)
            .then(function (response) {
                return response.data;
            });
    }


    static getImages(url) {
        return axios.get(url)
            .then(function (response) {
                return response.data;
                //console.log(response.data); // ex.: { user: 'Your User'}
                //console.log(response.status); // ex.: 200
            });
    }


}